export default function StepDocumentType({ session, updateSession, onNext, onBack }) {
  const select = (type) => {
    updateSession({ docType: type });
    onNext();
  };

  return (
    <div className="step-card">
      <div className="step-icon">
        <span className="material-symbols-outlined">id_card</span>
      </div>
      <h1>Choose your ID document</h1>
      <p className="step-sub">
        Select the document you'll use to verify your identity. Make sure it's current and not expired.
      </p>

      <div className="doc-type-grid">
        <button className="doc-type-card" onClick={() => select("DRIVER_LICENSE")}>
          <div className="doc-type-visual dl">
            <span className="material-symbols-outlined" style={{ fontSize: '44px', color: 'rgba(255,255,255,0.85)' }}>id_card</span>
          </div>
          <h3>Driver's License / State ID</h3>
          <p>US driver's license or government-issued photo ID card</p>
          <span className="doc-badge">Most common</span>
        </button>

        <button className="doc-type-card" onClick={() => select("PASSPORT")}>
          <div className="doc-type-visual passport">
            <span className="material-symbols-outlined" style={{ fontSize: '44px', color: 'rgba(255,255,255,0.85)' }}>passport</span>
          </div>
          <h3>Passport</h3>
          <p>International passport from any country — data page only</p>
        </button>
      </div>

      <div className="info-block">
        <span className="info-icon">🔒</span>
        <span>Your document is encrypted at rest and only used for identity verification.</span>
      </div>

      <button className="btn-ghost" onClick={onBack}>← Back</button>
    </div>
  );
}
